import { WarrantyStatus } from '../enums';

export const calculateWarrantyStatus = (
    warrantyMonths: number | undefined,
    warrantyMiles: number | undefined | null,
    inServiceDate: string | undefined,
    currentOdometer: number | undefined
): {
    status: WarrantyStatus;
    isExpired: boolean;
    remainingMonths: number | undefined;
    remainingMiles: number | undefined;
} => {
    // If no warranty limits are set, treat as Active with no expiry tracking
    if (!warrantyMonths && !warrantyMiles) {
        return {
            status: WarrantyStatus.Active,
            isExpired: false,
            remainingMonths: undefined,
            remainingMiles: undefined
        };
    }

    // If no in-service date or odometer, cannot determine status accurately
    if (!inServiceDate || currentOdometer === undefined) {
        return {
            status: WarrantyStatus.Active,
            isExpired: false,
            remainingMonths: warrantyMonths,
            remainingMiles: warrantyMiles ?? undefined
        };
    }

    const inService = new Date(inServiceDate);
    const now = new Date();

    // Calculate months elapsed since in-service date
    const monthsElapsed = (now.getFullYear() - inService.getFullYear()) * 12 + (now.getMonth() - inService.getMonth());

    const remainingMonths = warrantyMonths ? warrantyMonths - monthsElapsed : undefined;
    const remainingMiles = warrantyMiles ? warrantyMiles - currentOdometer : undefined;

    const timeExpired = warrantyMonths ? remainingMonths! <= 0 : false;
    const milesExpired = warrantyMiles ? remainingMiles! <= 0 : false;

    let status: WarrantyStatus;
    if (timeExpired || milesExpired) {
        status = WarrantyStatus.Expired;
    } else {
        status = WarrantyStatus.Active;
    }

    const isExpired = timeExpired || milesExpired;

    return {
        status,
        isExpired,
        remainingMonths,
        remainingMiles
    };
};
